/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeCircleMOffIcon16Regular = forwardRef('ShapeCircleMOffIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.53 1.47a.75.75 0 0 0-1.06 1.06l1.79 1.79a6 6 0 0 0 8.42 8.42l1.79 1.79a.75.75 0 1 0 1.06-1.06l-12-12Zm8.077 10.198L4.332 5.393a4.5 4.5 0 0 0 6.275 6.276Z" }),
        React.createElement("path", { d: "M12.5 8c0 .52-.088 1.018-.25 1.482l1.146 1.146a6 6 0 0 0-8.023-8.023L6.517 3.75A4.5 4.5 0 0 1 12.5 8Z" })));
});
